<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12" md="12" lg="5">
                        <v-autocomplete v-model="AreasCurva" :items="AreasCurvaItems" outlined dense label="Áreas"
                            item-text="name" item-value="id" return-object @change="ModelateCurva"
                            style="max-width: 300px;"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12" lg="7" class="d-flex gap-10px">
                        <v-card outlined style="min-width: 200px;">
                            <v-card-text>
                                <v-row dense class="d-flex justify-center">
                                    <v-col cols="12" class="d-flex justify-center">
                                        <v-chip color="primary" label small>
                                            Nota literal
                                        </v-chip>
                                    </v-col>
                                    <v-col cols="12" class="d-flex justify-center align-center"
                                        style="min-height: 100px;">
                                        {{ notaLiteral }}
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card outlined>
                            <v-card-text>
                                <v-row dense>
                                    <v-col cols="12" class="d-flex justify-center">
                                        <v-chip color="primary" label small>
                                            Área : {{ AreasCurva.name }}
                                        </v-chip>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row dense>

                                            <v-col cols="12" sm="5">
                                                <v-card outlined>
                                                    <v-card-text>
                                                        <v-row dense class="d-flex text-center">
                                                            <v-col cols="12" class="primary--text text-subtitle-2">
                                                                Pruebas
                                                            </v-col>
                                                            <v-col cols="12" md="6" lg="6">
                                                                <v-chip x-small label>
                                                                    Aprobados
                                                                </v-chip>
                                                                <br>
                                                                {{ AreasCurva.aprobados }}
                                                            </v-col>
                                                            <v-col cols="12" md="6" lg="6">
                                                                <v-chip x-small label>Desaprobados</v-chip>
                                                                <br>
                                                                {{ AreasCurva.desaprobados }}
                                                            </v-col>
                                                        </v-row>

                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="12" sm="7">
                                                <v-card outlined>
                                                    <v-card-text>
                                                        <v-row dense class="d-flex text-center">
                                                            <v-col cols="12" class="primary--text text-subtitle-2">
                                                                Preguntas
                                                            </v-col>
                                                            <v-col cols="12" md="3">
                                                                <v-chip x-small label>Total</v-chip>
                                                                <br>
                                                                {{ AreasCurva.total }}
                                                            </v-col>
                                                            <v-col cols="12" md="4">
                                                                <v-chip x-small label>Correctas</v-chip>
                                                                <br>
                                                                {{ AreasCurva.correctas }}
                                                            </v-col>
                                                            <v-col cols="12" md="5">
                                                                <v-chip x-small label>Incorrectas</v-chip>
                                                                <br>
                                                                {{ AreasCurva.incorrectas }}
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="5">
                <v-card outlined>
                    <v-card-title class="d-flex justify-center text-subtitle-2 primary--text">
                        Registro de somos hábiles
                    </v-card-title>
                    <v-card-text>

                        <!-- {{ AreasCurva.name }} -->
                        <ComundataTablecomp :headers="CurvadaprendizajeHeaders" :items="dataCurva">
                            <template v-slot:fecha_creacion="{ item }">
                                {{ formatFec(item.fecha_creacion) }}
                            </template>
                            <template v-slot:verdaderas="{ item }">
                                <v-chip color="success" label small>
                                    {{ item.verdaderas }}
                                </v-chip>
                            </template>
                            <template v-slot:falsas="{ item }">
                                <v-chip color="red" label small dark>
                                    {{ parseInt(item.cantidad_preguntas) - parseInt(item.verdaderas) }}
                                </v-chip>
                            </template>
                            <template v-slot:aprobado="{ item }">
                                <v-chip :color="item.aprobado ? 'green' : 'red'" dark label small>
                                    {{ item.aprobado ? 'Aprobado' : 'Reprobado' }}
                                </v-chip>
                            </template>
                        </ComundataTablecomp>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="7">
                <v-card outlined>
                    <v-card-title class="d-flex justify-center text-subtitle-2 primary--text">
                        Curva de aprendizaje
                    </v-card-title>
                    <v-card-text>
                        <div id="chart">
                            <apexchart type="area" height="350" :options="chartOptions2" :series="series2">
                            </apexchart>
                        </div>

                    </v-card-text>
                    <v-card-subtitle class="d-flex text-center">
                        El siguiente gráfico muestra el progreso de aprendizaje del estudiante esperado, en relación a
                        la cantidad total de preguntas que se dieron en los somos hábiles a cabo en el periodo de fechas
                        registradas
                    </v-card-subtitle>
                </v-card>

            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from "@/helpers/axios";
import VueApexCharts from 'vue-apexcharts'
import { CurvadaprendizajeHeaders } from "../../../../helpers/headersTable";
import ComundataTablecomp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import moment from "moment";
export default {

    props: ['filter'],
    components: {
        apexchart: VueApexCharts,
        ComundataTablecomp
    },
    data: () => ({
        // modificadores de interfaz
        CurvadaprendizajeHeaders,
        notaLiteral: "",
        Somoshabiles: [],
        Areas: [],
        AreasCurvaItems: [],
        Notas: [],
        dataCurva: [],
        AreasCurva: [],
        AreasSeleccionadas: [],




        series2: [],
        chartOptions2: {
            markers: {
                size: 4, // Tamaño de los marcadores. Ajusta esto según necesites.
                opacity: 1, // Opacidad de los marcadores. 1 significa completamente opaco.
                colors: undefined, // Color de los marcadores. Puedes definir colores específicos o dejarlo undefined para usar los predeterminados.
                strokeColor: "#fff", // Color del borde de los marcadores.
                strokeWidth: 2, // Grosor del borde de los marcadores.
                hover: {
                    size: 6, // Tamaño de los marcadores al hacer hover.
                    sizeOffset: 3 // El valor por el cual incrementar el tamaño del marcador al hacer hover.
                }
            },
            chart: {
                height: 350,
                type: 'line'
            },

            row: {
                colors: undefined,
                opacity: 0.5
            },
            column: {
                colors: undefined,
                opacity: 0.5
            },

            xaxis: {
                type: 'datetime',
                categories: [],
                lines: {
                    show: true
                }
            },

            yaxis: {


                labels: {
                    formatter: (val) => {
                        // if (val > 100 || val < 0) {
                        //     return ""
                        // }
                        return val + "%"
                    },
                },
                min: 0,
                max: 100,
                forceNiceScale: false,
                tickAmount: 10
            },

            grid: {
                show: true,
                borderColor: '#90A4AE',
                strokeDashArray: 0,
                position: 'back',
                xaxis: {
                    lines: {
                        show: true
                    }
                },
                yaxis: {
                    lines: {
                        show: true
                    }
                },
                row: {
                    colors: undefined,
                    opacity: 0.5
                },
                column: {
                    colors: undefined,
                    opacity: 0.5
                },
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },
            },

            dataLabels: {
                enabled: false
            },

            tooltip: {
                x: {
                    format: 'dd/MM/yy HH:mm'
                },
                y: {
                    formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return y.toFixed(2) + "%";
                        }
                        return y;
                    }
                }
            },
        }

    }),


    methods: {

        formatFec(fecha) {
            return moment(fecha).format("DD/MM/YYYY");
        },

        async fetchDataFromAPI() {
            const response = await axios.get("/metricaSomosHabiles/barChartByArea", {
                params: {
                    tipo_eval: "SOMOS HÁBILES",
                    id_al: this.filter.id_alumno,
                    status: false
                }
            });
            this.Somoshabiles = response.data.data;
            this.AreasCurvaItems = response.data.data
            this.processAPIDataCurva(this.AreasCurvaItems)
        },








        processAPIDataCurva(apiData) {
            this.AreasCurvaItems = apiData.map(item => {
                const correctas = item.evaluaciones.reduce((total, evaluacion) => total + evaluacion.verdaderas, 0);
                const incorrectas = item.evaluaciones.reduce((total, evaluacion) => total + (evaluacion.cantidad_preguntas - evaluacion.verdaderas), 0);
                const totalPreguntas = item.evaluaciones.reduce((total, evaluacion) => total + evaluacion.cantidad_preguntas, 0);

                return {
                    id: item.id_area,
                    name: item.desc_area,
                    aprobados: item.aprobados,
                    desaprobados: item.desaprobados,
                    correctas: correctas,
                    incorrectas: incorrectas,
                    total: totalPreguntas,
                    data: item.evaluaciones,
                };
            });
        },




        async ModelateCurva() {
            // console.log('Esta es AreaCurva seleccionada', this.AreasCurva);
            let params = { "id_colegio": sessionStorage.id_colegio, "id_ano_lectivo": sessionStorage.id_ano_lectivo }
            let response = await axios.post("/administrativo/confNotaLiteral/getConfiguracionLiteral/", params)
            this.Notas = response.data;
            console.log('Esta es la nota', this.Notas);
            if (this.AreasCurva && this.AreasCurva.data) {
                let totalPruebas = this.AreasCurva.data.length;
                let TempSomoshabiles = this.AreasCurva.data.map(item => {
                    return ((parseInt(item.verdaderas) / parseInt(item.cantidad_preguntas)) * 100) / totalPruebas;
                });
                let sumaAcumulativa = 0;
                let sumaAcumulativaArray = TempSomoshabiles.map(valor => sumaAcumulativa += valor);
                let fechasSomos = this.AreasCurva.data.map(item => item.fecha_creacion);

                this.dataCurva = this.AreasCurva.data

                this.chartOptions2 = {
                    ...this.chartOptions2,
                    xaxis: {
                        ...this.chartOptions2.xaxis, // Esto copia la configuración existente del eje X
                        categories: fechasSomos // Esto establece las nuevas categorías
                    }
                };

                this.$nextTick(() => {
                    if (this.$refs.myChart) {
                        this.$refs.myChart.updateOptions(this.chartOptions2, true, true);
                    }
                });

                // this.chartOptions2.xaxis.categories = fechasSomos;

                this.series2 = [{
                    name: 'Somos hábiles',
                    data: sumaAcumulativaArray
                }];

                // 0 - 10 = C
                // 11 - 13 = B
                // 14 - 17 = A
                // 18 - 20 = AD
                // EQUIVALENCIAS
                // C: 0% - 50%
                // B: 51% - 65%
                // A: 66% - 85%
                // AD: 86% - 100%
                if (sumaAcumulativaArray.length > 0) {
                    // Obtenemos el último valor del array

                    const ultimoValor = sumaAcumulativaArray[sumaAcumulativaArray.length - 1];
                    if (ultimoValor >= 86) {
                        this.notaLiteral = 'AD'
                    } else if (ultimoValor >= 66) {
                        this.notaLiteral = 'A';
                    } else if (ultimoValor >= 51) {
                        this.notaLiteral = 'B'
                    } else if (ultimoValor >= 0) {
                        this.notaLiteral = 'C'
                    }


                } else {
                    console.error("El array sumaAcumulativaArray está vacío");
                }
                // this.chartKey = Date.now()
                // console.log('Esta es la data modificada', this.series2);
            } else {
                console.error('No se pudo encontrar el array de datos en AreasCurva');
            }
        }
    },


    mounted() {
        // this.fetchDataGada()
        this.fetchDataFromAPI()
    },




}
</script>
